/* eslint-disable camelcase */
import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { IconWarning } from '@lightspeed/flame/Icon/Warning';
import { Text } from '@lightspeed/flame/Text';

type Props = {
  rowCount: number;
  onReload: () => void;
};

/**
 * The LoadError component has two views depending on the number of shops
 * on the customer account, to fit the design.
 * @param rowCount The total number of shops
 * @param onReload A callback to reload the data on error
 * @returns
 */
export const LoadError: React.FC<Props> = ({ rowCount, onReload }) => {
  if (rowCount < 5) {
    return (
      <div>
        <Text>Unable to load table. Refresh the data to try again.</Text>
        <Button type="button" mt={12} onClick={onReload}>
          Refresh data
        </Button>
      </div>
    );
  }

  return (
    <div>
      <IconWarning />
      <Text mt={2} fontSize={16} fontWeight={700} lineHeight={24} color="#020203">
        Unable to load table
      </Text>
      <Text fontSize={14} fontWeight={400} lineHeight={18} color="#5C626A">
        Refresh the data or wait a moment and try again.
      </Text>
      <Button type="button" mt={36} onClick={onReload}>
        Refresh data
      </Button>
    </div>
  );
};
